/**
 * Builds the user-search query a privileged client (superadmin/support masquerade) sends to
 * scope a dropdown to the current company's active users. Every call site that skips this and
 * hand-rolls the query string risks re-introducing #21857/ENG-1004 (deactivated or cross-company
 * users leaking into estimator/owner dropdowns) — extracted so there's exactly one place to get
 * it right.
 *
 * Non-privileged sessions send `''` and rely on the server's own default scoping.
 */
export function buildScopedUserQuery({ isPrivileged, clientId }: { isPrivileged: boolean; clientId: string }): string {
  return isPrivileged ? `app_metadata.companyId:"${clientId}" AND app_metadata.active:true` : ''
}
